import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
  } from "../../config/axiosInstance";
  
export const childListApi = async (data) => {
  const endPoint = `admin/child/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
  
export const childDetailApi = async (data) => {
  const endPoint = `admin/child?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

export const addChildApi = async (data) => {
    const endPoint = `admin/child`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};

export const updateChildApi = async (data) => {
    const endPoint = `admin/child`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};

export const deleteChildApi = async (data) => {
  const endPoint = `admin/child?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.delete(endPoint, setJwtToken());
};

export const childDashboardDetailApi = async (data) => {
  const endPoint = `admin/child/dashboard?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
